// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container covers full width and reserves space for the top menu */
.AudioSeries_mainContainer__WnA5l {
  width: 100%;
  background-color: #1f1d1d;
  padding: 20px;
  box-sizing: border-box;
}

/* Reserved space for your menu */
.AudioSeries_topMenu__FkrGv {
  height: 80px; /* Adjust as needed */
}

/* Boxed container with a max-width of 1200px */
.AudioSeries_contentBox__49F-1 {
  max-width: 1400px;
  margin: 0 auto;
}

/* Audio series container */
.AudioSeries_audioSeriesContainer__1dNzQ {
  position: relative;
  max-height: 75vh;
}

/* Wrapper for slider; this is where we attach touch event listeners */
.AudioSeries_sliderWrapper__TNgLG {
  position: relative;
}

/* Slider: holds slides with overflow hidden and rounded corners */
.AudioSeries_slider__02Ils {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 12px;
  max-height: 75vh;
}

/* Each slide is absolutely positioned; only the active slide is visible */
.AudioSeries_slide__yhBia {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.AudioSeries_active__EUqWG {
  opacity: 1;
}

/* Card wrapper with rounded corners and a blue border shadow */
.AudioSeries_cardWrapper__dbQUL {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(0, 157, 255, 0.3);
  font-family: 'Arial', sans-serif;
  max-height: 75vh;
}

.AudioSeries_imageContainer__2JsS\\+ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 75vh;
}

.AudioSeries_backgroundImage__qQwNr {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transform: scale(1.02);
}

.AudioSeries_overlay__dd5Wm {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.4) 100%
  );
}

.AudioSeries_category__rj5Pa {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  backdrop-filter: blur(4px);
  z-index: 2;
}

/* Content: placed at the bottom with space between text and button */
.AudioSeries_content__pUB3o {
  position: relative;
  z-index: 2;
  padding: 40px;
  color: #fff;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  box-sizing: border-box;
  
}

/* Left-side text content */
.AudioSeries_textContent__dFJFP {
  max-width: 70%;
}

.AudioSeries_title__NKxK7 {
  margin-bottom: 1rem;
  font: small-caps bold 65px Georgia, serif;
  font-optical-sizing: auto;
}

.AudioSeries_description__hG6Zx {
  font-size: 1rem;
  max-width: 600px;
  margin-bottom: 1rem;
  opacity: 0.9;
  line-height: 1.6;
}

.AudioSeries_metadata__VPwqN {
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  opacity: 0.8;
}

/* Red “Listen Now” button on the right */
.AudioSeries_listenButton__VwY2Z {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #ff0000;
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.AudioSeries_playIcon__FhKEi {
  font-size: 0.8rem;
}

.AudioSeries_listenButton__VwY2Z:hover {
  background-color: #cc0000;
}

/* Slider control indicators */
.AudioSeries_sliderControls__wlsXF {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 20px;
}

.AudioSeries_indicator__YzmSs {
  width: 40px;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.AudioSeries_activeIndicator__cFXnB {
  background-color: #ff0000;
}

/* Navigation Buttons */
.AudioSeries_navButton__Qd7Lg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  color: #fff;
  font-size: 2rem;
  padding: 8px 12px;
  cursor: pointer;
  z-index: 3;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.AudioSeries_navButton__Qd7Lg:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.AudioSeries_prevButton__zVRXY {
  left: 10px;
}

.AudioSeries_nextButton__4fS4W {
  right: 10px;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .AudioSeries_title__NKxK7 {
    font-size: 2.8rem;
  }
  
  .AudioSeries_content__pUB3o {
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .AudioSeries_title__NKxK7 {
    font-size: 2.2rem;
  }
  
  .AudioSeries_description__hG6Zx {
    font-size: 0.9rem;
  }
  
  .AudioSeries_content__pUB3o {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .AudioSeries_category__rj5Pa {
    padding: 4px 12px;
    font-size: 0.8rem;
  }
  
  .AudioSeries_listenButton__VwY2Z {
    margin-top: 10px;
    padding: 10px 20px;
    font-size: 0.9rem;
  }
  
  /* Adjust navigation button size for touch devices */
  .AudioSeries_navButton__Qd7Lg {
    font-size: 1.8rem;
    padding: 6px 10px;
  }
}

@media (max-width: 480px) {
  .AudioSeries_title__NKxK7 {
    font-size: 18px;
  }
  
  .AudioSeries_description__hG6Zx {
    font-size: 12px;
    line-height: 0px;
  }
  
  .AudioSeries_metadata__VPwqN {
    font-size: 0.8rem;
  }
  
  .AudioSeries_listenButton__VwY2Z {
    padding: 8px 16px;
    font-size: 0.8rem;
  }
  
  .AudioSeries_indicator__YzmSs {
    width: 30px;
  }
  
  .AudioSeries_content__pUB3o {
    padding: 15px 50px;
  }
  
  .AudioSeries_navButton__Qd7Lg {
    font-size: 1.6rem;
    padding: 4px 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/AudioSeries/Components/CSS/AudioSeries.module.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,YAAY,EAAE,qBAAqB;AACrC;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;;AAExB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,oDAAoD;EACpD;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["/* Main container covers full width and reserves space for the top menu */\n.mainContainer {\n  width: 100%;\n  background-color: #1f1d1d;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Reserved space for your menu */\n.topMenu {\n  height: 80px; /* Adjust as needed */\n}\n\n/* Boxed container with a max-width of 1200px */\n.contentBox {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Audio series container */\n.audioSeriesContainer {\n  position: relative;\n  max-height: 75vh;\n}\n\n/* Wrapper for slider; this is where we attach touch event listeners */\n.sliderWrapper {\n  position: relative;\n}\n\n/* Slider: holds slides with overflow hidden and rounded corners */\n.slider {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  border-radius: 12px;\n  max-height: 75vh;\n}\n\n/* Each slide is absolutely positioned; only the active slide is visible */\n.slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.active {\n  opacity: 1;\n}\n\n/* Card wrapper with rounded corners and a blue border shadow */\n.cardWrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 0 0 1px rgba(0, 157, 255, 0.3);\n  font-family: 'Arial', sans-serif;\n  max-height: 75vh;\n}\n\n.imageContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  max-height: 75vh;\n}\n\n.backgroundImage {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  transform: scale(1.02);\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.4) 0%,\n    rgba(0, 0, 0, 0.2) 40%,\n    rgba(0, 0, 0, 0.4) 100%\n  );\n}\n\n.category {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  backdrop-filter: blur(4px);\n  z-index: 2;\n}\n\n/* Content: placed at the bottom with space between text and button */\n.content {\n  position: relative;\n  z-index: 2;\n  padding: 40px;\n  color: #fff;\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  box-sizing: border-box;\n  \n}\n\n/* Left-side text content */\n.textContent {\n  max-width: 70%;\n}\n\n.title {\n  margin-bottom: 1rem;\n  font: small-caps bold 65px Georgia, serif;\n  font-optical-sizing: auto;\n}\n\n.description {\n  font-size: 1rem;\n  max-width: 600px;\n  margin-bottom: 1rem;\n  opacity: 0.9;\n  line-height: 1.6;\n}\n\n.metadata {\n  font-size: 0.9rem;\n  margin-bottom: 1.5rem;\n  opacity: 0.8;\n}\n\n/* Red “Listen Now” button on the right */\n.listenButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #ff0000;\n  color: #fff;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 50px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.playIcon {\n  font-size: 0.8rem;\n}\n\n.listenButton:hover {\n  background-color: #cc0000;\n}\n\n/* Slider control indicators */\n.sliderControls {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.indicator {\n  width: 40px;\n  height: 4px;\n  background-color: rgba(255, 255, 255, 0.3);\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.activeIndicator {\n  background-color: #ff0000;\n}\n\n/* Navigation Buttons */\n.navButton {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.6);\n  border: none;\n  color: #fff;\n  font-size: 2rem;\n  padding: 8px 12px;\n  cursor: pointer;\n  z-index: 3;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n}\n\n.navButton:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.prevButton {\n  left: 10px;\n}\n\n.nextButton {\n  right: 10px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .title {\n    font-size: 2.8rem;\n  }\n  \n  .content {\n    padding: 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .title {\n    font-size: 2.2rem;\n  }\n  \n  .description {\n    font-size: 0.9rem;\n  }\n  \n  .content {\n    padding: 20px;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .category {\n    padding: 4px 12px;\n    font-size: 0.8rem;\n  }\n  \n  .listenButton {\n    margin-top: 10px;\n    padding: 10px 20px;\n    font-size: 0.9rem;\n  }\n  \n  /* Adjust navigation button size for touch devices */\n  .navButton {\n    font-size: 1.8rem;\n    padding: 6px 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .title {\n    font-size: 18px;\n  }\n  \n  .description {\n    font-size: 12px;\n    line-height: 0px;\n  }\n  \n  .metadata {\n    font-size: 0.8rem;\n  }\n  \n  .listenButton {\n    padding: 8px 16px;\n    font-size: 0.8rem;\n  }\n  \n  .indicator {\n    width: 30px;\n  }\n  \n  .content {\n    padding: 15px 50px;\n  }\n  \n  .navButton {\n    font-size: 1.6rem;\n    padding: 4px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `AudioSeries_mainContainer__WnA5l`,
	"topMenu": `AudioSeries_topMenu__FkrGv`,
	"contentBox": `AudioSeries_contentBox__49F-1`,
	"audioSeriesContainer": `AudioSeries_audioSeriesContainer__1dNzQ`,
	"sliderWrapper": `AudioSeries_sliderWrapper__TNgLG`,
	"slider": `AudioSeries_slider__02Ils`,
	"slide": `AudioSeries_slide__yhBia`,
	"active": `AudioSeries_active__EUqWG`,
	"cardWrapper": `AudioSeries_cardWrapper__dbQUL`,
	"imageContainer": `AudioSeries_imageContainer__2JsS+`,
	"backgroundImage": `AudioSeries_backgroundImage__qQwNr`,
	"overlay": `AudioSeries_overlay__dd5Wm`,
	"category": `AudioSeries_category__rj5Pa`,
	"content": `AudioSeries_content__pUB3o`,
	"textContent": `AudioSeries_textContent__dFJFP`,
	"title": `AudioSeries_title__NKxK7`,
	"description": `AudioSeries_description__hG6Zx`,
	"metadata": `AudioSeries_metadata__VPwqN`,
	"listenButton": `AudioSeries_listenButton__VwY2Z`,
	"playIcon": `AudioSeries_playIcon__FhKEi`,
	"sliderControls": `AudioSeries_sliderControls__wlsXF`,
	"indicator": `AudioSeries_indicator__YzmSs`,
	"activeIndicator": `AudioSeries_activeIndicator__cFXnB`,
	"navButton": `AudioSeries_navButton__Qd7Lg`,
	"prevButton": `AudioSeries_prevButton__zVRXY`,
	"nextButton": `AudioSeries_nextButton__4fS4W`
};
export default ___CSS_LOADER_EXPORT___;
